<app-change-course-header
  [heading]="'Admin: Study Unit: Practice Test : List'"
  [showChangeCourse]="true"
  (addMockExam)="AddEditPracticeTest()"
></app-change-course-header>
<div class="row align-items-center  mt-3 mb-2 bg-secondary bg-opacity-10 rounded p-2 border">
  <div class="col-auto">
    <label for="subject" class="fw-semibold mb-0 text-dark" style="font-size: 1.2rem;">
      Subject:
    </label>
  </div>
  <div class="col-auto">
    <select
      id="subject"
      class="form-select form-select-md"
      style="width: 200px; min-width: 140px;"
      [formControl]="subjectControl"
      [compareWith]="compareStringValues"
    >
      <option [ngValue]="''" disabled>Select Subject</option>
      <option *ngFor="let subject of subjects" [ngValue]="subject.Code">
        {{ subject.Description }}
      </option>
    </select>
  </div>
</div>


<div class="row mt-4">
  <div class="table-responsive px-0">
    <table class="table table-bordered" #table1>
      <thead class="table-light">
        <tr>
          <th
            sortable="Course_Test_Id"
            (sort)="onSort($event)"
            rowspan="2"
            style="
              vertical-align: middle;
              text-align: center;
              width: 3%;
              white-space: wrap;
            "
          >
            Test ID
            <i
              *ngIf="sortColumn === 'Course_Test_Id'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            rowspan="2"
            sortable="Path_Name"
            (sort)="onSort($event)"
            style="
              vertical-align: middle;
              text-align: center;
              width: 25%;
              white-space: wrap;
            "
          >
          Topic
            <i
              *ngIf="sortColumn === 'Path_Name'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            rowspan="2"
            sortable="Study_Unit_Name"
            (sort)="onSort($event)"
            style="
              vertical-align: middle;
              text-align: center;
              width: 12%;
              white-space: wrap;
            "
          >
          Study Unit Name
            <i
              *ngIf="sortColumn === 'Study_Unit_Name'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
          rowspan="2"
          sortable="Number_Of_Questions"
          (sort)="onSort($event)"
          style="
            vertical-align: middle;
            text-align: center;
            width: 50px;
            min-width: 35px;
            max-width: 88px;
            white-space: wrap;
            overflow: hidden;
          "
        >
          # of Questions
          <i
            *ngIf="sortColumn === 'Number_Of_Questions'"
            class="ms-1 fa"
            [class.fa-sort-asc]="sortDirection === 'asc'"
            [class.fa-sort-desc]="sortDirection === 'desc'"
            [class.mt-2]="sortDirection === 'desc'"
          ></i>
        </th>

          <th
            rowspan="2"
            sortable="Mock_Exam_Status_Type_Code"
            (sort)="onSort($event)"
            style="
            vertical-align: middle;
            text-align: center;
            width: 50px;
            min-width: 35px;
            max-width: 88px;
            white-space: wrap;
            overflow: hidden;
          "
          >
            Status
            <i
              *ngIf="sortColumn === 'Mock_Exam_Status_Type_Code'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>

          <th rowspan="2" class="audit-info-col" style="vertical-align: middle; text-align: center;">
            <div>
              <span>Created By</span>
              <span class="text-muted">&nbsp;/&nbsp;</span>
              <span>Created Time</span>
            </div>
            <div>
              <span>Updated By</span>
              <span class="text-muted">&nbsp;/&nbsp;</span>
              <span>Updated Time</span>
            </div>
          </th>



          <th
            [attr.colspan]="courses && courses.length > 0 ? courses.length : 1"
            style="text-align: center; width: 34%"
          >
            Applicable Course Plan
          </th>
          <th rowspan="2"></th>
        </tr>
        <tr>
          <th
          *ngFor="let item of courses"
           sortable="{{ item.Description }}"
           class="small-th"
           >
            {{ getPlanNameInitails(item.Description) }}
            <!-- <i
              *ngIf="sortColumn === item.Description"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i> -->
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
        *ngFor="let item of practiceTest"
        [ngClass]="{'table-primary': selectedPracticeTestId === item.Course_Test_Id}"
        (click)="selectPracticeTest(item)"
        style="cursor: pointer;"
      >
        <td>{{ item.Course_Test_Id }}</td>
        <td class="text-start">{{ item.Path_Name }}</td>
        <td class="text-start">{{ item.Study_Unit_Name }}</td>
        <td>{{ item.Number_Of_Questions }}</td>
        <td>{{ item.Course_Test_Status_Type_Code }}</td>
        <td>
          <div class="d-flex flex-wrap align-items-center">
            <span>
              <span class="fw-semibold text-md">Created:</span>
              {{ item.Created_By || '-' }}
              <span class="text-muted text-md small ms-1">{{ item.Creation_Date ? (item.Creation_Date | date: 'short') : '-' }}</span>
            </span>
            <span>
              <span class="fw-semibold text-md">Updated:</span>
              {{ item.Updated_By || '-' }}
                <span class="text-muted text-md small ms-1">{{ item.Updation_Date ? (item.Updation_Date | date: 'short') : '-' }}</span>
            </span>
          </div>
        </td>
        <td *ngFor="let course of courses">
          <input
            disabled
            class="form-check-input"
            type="checkbox"
            [checked]="item.Course_Plan_Type_Codes?.includes(course.Code)"
          />
        </td>
        <td style="vertical-align: middle; text-align: center; width: 2%; white-space: wrap;">
          <div class="d-flex gap-2 justify-content-center">
            <i
              class="fa fa-edit pointer-cursor"
              title="Edit Exam"
              (click)="AddEditPracticeTest(item); $event.stopPropagation();"
            ></i>
            <i
              class="fa fa-link pointer-cursor"
              title="Mock Exam Questions"
              (click)="navigateToPracticeQuestions(item); $event.stopPropagation();"
              aria-hidden="true"
            ></i>
          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</div>
